import { setTimeoutOnWorker } from '../utils/scheduler';

export class Task<S> {
  public workState: S;
  private taskState: {
    readonly paused: boolean;
    readonly finished: boolean;
  } = {
    paused: true,
    finished: false,
  };
  constructor(
    public initialState: S,
    public performWork: (state: S) => Promise<S | void>,
    public options: {
      rateLimit: number;
      onFinish?: (state: S) => void;
      onProgress?: (state: S) => void;
    }
  ) {
    this.workState = initialState;
  }
  public getTaskState = () => this.taskState;
  public pause = () => {
    if (this.taskState.finished) {
      return;
    }
    this.taskState = {
      paused: true,
      finished: false,
    };
  };

  public start = async () => {
    if (this.taskState.finished) {
      return this.workState;
    }
    if (this.taskState.paused === true) {
      this.taskState = {
        paused: false,
        finished: false,
      };

      let rateTimeoutPromise = setTimeoutOnWorker(this.options.rateLimit);
      while (true) {
        if (this.taskState.finished || this.taskState.paused) {
          rateTimeoutPromise = setTimeoutOnWorker(this.options.rateLimit);
          break;
        }
        const result = await this.performWork(this.workState);
        await rateTimeoutPromise;

        if (this.taskState.finished || this.taskState.paused) {
          rateTimeoutPromise = setTimeoutOnWorker(this.options.rateLimit);
          break;
        }
        if (!result) {
          this.finish();
          break;
        } else {
          if (this.options.onProgress) {
            this.options.onProgress(result);
          }
          this.workState = result;
          rateTimeoutPromise = setTimeoutOnWorker(this.options.rateLimit);
        }
      }
    }
    return;
  };

  public finish = () => {
    if (this.taskState.finished) {
      return;
    }
    this.taskState = {
      paused: false,
      finished: true,
    };
    if (this.options.onFinish) {
      this.options.onFinish(this.workState);
    }
  };
}
